export default __webpack_public_path__ + "static/media/genuine-chronology.dae94594.png";